$(function () {
    $(".hoverable").on("mouseleave", function () {
        let collapse_div = $(this).find(".header-toggle").attr("href");
        $(collapse_div).collapse("hide");
    });

    $(".mobile-menu-general .py-2 > a").click(function() {
        if (!$(this).hasClass("dropdown-toggle")) {
            $(this).find("img").addClass("invisible");

            let markup = "<div id='loading-div' class='mx-auto'>"
                + "<div class='loader'></div>"
                + "</div>";
            $(this).prepend($(markup));
        }
    });

    $(window).on('unload', function() {
        $("#loading-div").remove();
        $(".mobile-menu-general img").removeClass("invisible");
    });
});
